import React from "react";
import { Container } from "react-bootstrap";
import { NavBar } from "../navbar/navbar";
import { ForecastValidationChart } from "./ForecastValidationChart";
import { ModelComparison } from "./ModelComparison";
import { useLanguage } from "../../i18n/LanguageProvider";
import "../../styles/sp-ui.css";
import "./Analytics.css";

interface AnalyticsProps {
  /** When true, render without the navbar / page-shell so the component can be
   *  embedded inside another page (e.g. the Admin sidenav as a tab). */
  embedded?: boolean;
}

// Forecast accuracy (admin): the model head-to-head scored against actual
// prices, then the time-travel chart for inspecting a single past forecast.
export const Analytics: React.FC<AnalyticsProps> = ({ embedded = false }) => {
  const { t } = useLanguage();

  const body = (
    <>
      {!embedded && (
        <div className="sp-page__head">
          <h1 className="sp-page__title">{t("analytics.title")}</h1>
          <p className="sp-page__sub">{t("analytics.subtitle")}</p>
        </div>
      )}
      <ModelComparison />
      <ForecastValidationChart />
    </>
  );

  if (embedded) return body;

  return (
    <>
      <NavBar />
      <Container fluid className="sp-page">
        {body}
      </Container>
    </>
  );
};
